// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"24bb32bc","239":"7949e7e2","453":"bc98a39d","455":"673b79cc"}[chunkId] + ".chunk.js";
};